export enum SegmentAccessType {
    FULL_ACCESS = 1,
    SPECIFIC_ACCESS = 2
}
